import React from 'react';
import { Table, Col, Form } from 'react-bootstrap';
import { TableHeader } from '../../Atoms/TableHeader/TableHeader';
import CustomCheck from '../../Atoms/CustomCheck/CustomCheck';
import MessageError from '../../Atoms/MessageError/MessageError';

const ReferenceTable = ({
    referenceList,
    parameters,
    control,
    errors,
    checkedRefs,
    checkedReferenceId,
    handleReferenceSelection,
    checkedTruthfulness,
    handleCheck,
    empyCheck,
    nameForm,
    setNameForm
}) => {
    setNameForm(parameters?.TABLA_CONTACTO?.value);
    return (
        
        <div className="customer-screen" style={{ padding: '0px' }}    >
            <p className="text-black bold">
                {nameForm}
            </p>
            <Table responsive>
                <thead>
                    <tr>
                        <TableHeader value={parameters?.LBL_TABLE_SELECT?.value || '...'} width="15%" center />
                        <TableHeader value={parameters?.LMS_INF_2?.value || '...'} width="30%" />
                        <TableHeader value={parameters?.LMS_INF_4?.value || '...'} width="25%" />
                        <TableHeader value={parameters?.SUBTABLE_EMAIL_LABEL?.value || '...'} width="30%" />
                    </tr>
                </thead>
                <tbody>
                    {referenceList.map((ref) => (
                        <tr key={ref.id} className="subtable-challenge">
                            <td>
                                <CustomCheck

                                    id={`ref-${ref.id}`}
                                    name="referenceSelection" // Usar el mismo name para comportamiento de radio button
                                    control={control}
                                    onChange={() => handleReferenceSelection(ref)}
                                    error={errors?.selectReference}
                                    htmlFor={`ref-${ref.id}`}
                                    type="radio" // Es más intuitivo usar radio buttons para una única selección
                                    value={ref.id}
                                    checked={checkedReferenceId === ref.id}
                                />
                            </td>
                            <td>{ref.first_name + ' ' + ref.last_name}</td>
                            <td>{ref.dial_code + ref.phone_number}</td>
                            <td>{ref.email}</td>
                        </tr>
                    ))}
                </tbody>
            </Table>
            <div className="pt-2">

                {empyCheck && (
                    <MessageError message={parameters?.ERR_MSG_5?.description_value ?? 'El campo requerido'} />
                )}
            </div>
        </div>
    );
};

export default ReferenceTable;
